import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const isAdminPage = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");
  const adminToken = localStorage.getItem("torvi_admin_token");
  const userToken = localStorage.getItem("torvi_user_token");
  const token = isAdminPage ? adminToken : (userToken || adminToken);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fmtCLP = (n) =>
  new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", maximumFractionDigits: 0 }).format(n || 0);

export const CATEGORIES = [
  { key: "fundas_personalizadas", label: "Personalizadas" },
  { key: "fundas_amor", label: "Diseños Amor" },
  { key: "fundas_mascotas", label: "Diseños Mascotas" },
  { key: "fundas_gamer", label: "Diseños Gamer" },
  { key: "accesorios_iphone", label: "Accesorios iPhone" },
  { key: "emprende", label: "Emprende" },
];

// Comprehensive phone model catalog grouped by brand for filtering
export const PHONE_BRANDS = {
  iPhone: [
    "iPhone 16 Pro Max", "iPhone 16 Pro", "iPhone 16 Plus", "iPhone 16",
    "iPhone 15 Pro Max", "iPhone 15 Pro", "iPhone 15 Plus", "iPhone 15",
    "iPhone 14 Pro Max", "iPhone 14 Pro", "iPhone 14 Plus", "iPhone 14",
    "iPhone 13 Pro Max", "iPhone 13 Pro", "iPhone 13 Mini", "iPhone 13",
    "iPhone 12 Pro Max", "iPhone 12 Pro", "iPhone 12 Mini", "iPhone 12",
    "iPhone 11 Pro Max", "iPhone 11 Pro", "iPhone 11",
    "iPhone XS Max", "iPhone XS", "iPhone XR", "iPhone X",
    "iPhone SE (3ª gen)", "iPhone SE (2ª gen)",
    "iPhone 8 Plus", "iPhone 8", "iPhone 7 Plus", "iPhone 7",
  ],
  Samsung: [
    "Samsung Galaxy S25 Ultra", "Samsung Galaxy S25+", "Samsung Galaxy S25",
    "Samsung Galaxy S24 Ultra", "Samsung Galaxy S24+", "Samsung Galaxy S24", "Samsung Galaxy S24 FE",
    "Samsung Galaxy S23 Ultra", "Samsung Galaxy S23+", "Samsung Galaxy S23", "Samsung Galaxy S23 FE",
    "Samsung Galaxy S22 Ultra", "Samsung Galaxy S22+", "Samsung Galaxy S22",
    "Samsung Galaxy S21 Ultra", "Samsung Galaxy S21+", "Samsung Galaxy S21", "Samsung Galaxy S21 FE",
    "Samsung Galaxy S20 Ultra", "Samsung Galaxy S20+", "Samsung Galaxy S20", "Samsung Galaxy S20 FE",
    "Samsung Galaxy Note 20 Ultra", "Samsung Galaxy Note 20",
    "Samsung Galaxy Note 10+", "Samsung Galaxy Note 10",
    "Samsung Galaxy Z Fold 6", "Samsung Galaxy Z Flip 6",
    "Samsung Galaxy Z Fold 5", "Samsung Galaxy Z Flip 5",
    "Samsung Galaxy Z Fold 4", "Samsung Galaxy Z Flip 4",
    "Samsung Galaxy A55", "Samsung Galaxy A54", "Samsung Galaxy A53", "Samsung Galaxy A52",
    "Samsung Galaxy A35", "Samsung Galaxy A34", "Samsung Galaxy A33", "Samsung Galaxy A32",
    "Samsung Galaxy A25", "Samsung Galaxy A24", "Samsung Galaxy A23",
    "Samsung Galaxy A15", "Samsung Galaxy A14", "Samsung Galaxy A13",
    "Samsung Galaxy A05", "Samsung Galaxy A04", "Samsung Galaxy A03",
  ],
  Xiaomi: [
    "Xiaomi 14 Ultra", "Xiaomi 14 Pro", "Xiaomi 14", "Xiaomi 14T Pro", "Xiaomi 14T",
    "Xiaomi 13 Ultra", "Xiaomi 13 Pro", "Xiaomi 13", "Xiaomi 13T Pro", "Xiaomi 13T", "Xiaomi 13 Lite",
    "Xiaomi 12 Pro", "Xiaomi 12", "Xiaomi 12T Pro", "Xiaomi 12T", "Xiaomi 12 Lite",
    "Xiaomi 11T Pro", "Xiaomi 11T", "Xiaomi 11 Lite 5G",
    "Xiaomi Mi 11 Ultra", "Xiaomi Mi 11", "Xiaomi Mi 10 Pro", "Xiaomi Mi 10",
    "Xiaomi POCO F6 Pro", "Xiaomi POCO F6", "Xiaomi POCO F5 Pro", "Xiaomi POCO F5",
    "Xiaomi POCO X6 Pro", "Xiaomi POCO X6", "Xiaomi POCO X5 Pro", "Xiaomi POCO X5",
    "Xiaomi POCO M6 Pro", "Xiaomi POCO M5", "Xiaomi POCO M4 Pro",
  ],
  Redmi: [
    "Redmi Note 13 Pro+", "Redmi Note 13 Pro", "Redmi Note 13",
    "Redmi Note 12 Pro+", "Redmi Note 12 Pro", "Redmi Note 12", "Redmi Note 12S",
    "Redmi Note 11 Pro+", "Redmi Note 11 Pro", "Redmi Note 11S", "Redmi Note 11",
    "Redmi Note 10 Pro", "Redmi Note 10S", "Redmi Note 10",
    "Redmi Note 9 Pro", "Redmi Note 9S", "Redmi Note 9",
    "Redmi 13C", "Redmi 13", "Redmi 12C", "Redmi 12",
    "Redmi 11", "Redmi 10C", "Redmi 10", "Redmi 9C", "Redmi 9",
    "Redmi A3", "Redmi A2", "Redmi A1",
  ],
  Huawei: [
    "Huawei P60 Pro", "Huawei P60",
    "Huawei P50 Pro", "Huawei P50",
    "Huawei P40 Pro+", "Huawei P40 Pro", "Huawei P40", "Huawei P40 Lite",
    "Huawei P30 Pro", "Huawei P30", "Huawei P30 Lite",
    "Huawei P20 Pro", "Huawei P20", "Huawei P20 Lite",
    "Huawei Mate 60 Pro+", "Huawei Mate 60 Pro", "Huawei Mate 60",
    "Huawei Mate 50 Pro", "Huawei Mate 50",
    "Huawei Mate 40 Pro+", "Huawei Mate 40 Pro", "Huawei Mate 40",
    "Huawei Nova 12 Pro", "Huawei Nova 12", "Huawei Nova 11 Pro", "Huawei Nova 11",
    "Huawei Nova 10 Pro", "Huawei Nova 10", "Huawei Nova 9", "Huawei Nova 8",
    "Huawei Y9 Prime", "Huawei Y9", "Huawei Y7", "Huawei Y6",
  ],
  Honor: [
    "Honor Magic 6 Pro", "Honor Magic 6", "Honor Magic 6 Lite",
    "Honor Magic 5 Pro", "Honor Magic 5", "Honor Magic 5 Lite",
    "Honor Magic 4 Pro", "Honor Magic 4",
    "Honor 200 Pro", "Honor 200", "Honor 100 Pro", "Honor 100",
    "Honor 90 Pro", "Honor 90", "Honor 90 Lite",
    "Honor 70 Pro+", "Honor 70 Pro", "Honor 70",
    "Honor 50 Pro", "Honor 50", "Honor 50 Lite",
    "Honor X9b", "Honor X9a", "Honor X8a", "Honor X7a", "Honor X6a",
    "Honor View 30 Pro", "Honor View 30", "Honor View 20",
  ],
  Motorola: [
    "Motorola Edge 50 Ultra", "Motorola Edge 50 Pro", "Motorola Edge 50", "Motorola Edge 50 Fusion", "Motorola Edge 50 Neo",
    "Motorola Edge 40 Ultra", "Motorola Edge 40 Pro", "Motorola Edge 40", "Motorola Edge 40 Neo",
    "Motorola Edge 30 Ultra", "Motorola Edge 30 Pro", "Motorola Edge 30", "Motorola Edge 30 Neo", "Motorola Edge 30 Fusion",
    "Motorola Edge 20 Pro", "Motorola Edge 20", "Motorola Edge 20 Lite",
    "Motorola Razr 50 Ultra", "Motorola Razr 50", "Motorola Razr 40 Ultra", "Motorola Razr 40",
    "Motorola Moto G85", "Motorola Moto G84", "Motorola Moto G54", "Motorola Moto G34", "Motorola Moto G24", "Motorola Moto G14", "Motorola Moto G04",
    "Motorola Moto G73", "Motorola Moto G53", "Motorola Moto G23", "Motorola Moto G13",
    "Motorola Moto G62", "Motorola Moto G52", "Motorola Moto G42", "Motorola Moto G32", "Motorola Moto G22",
    "Motorola Moto E14", "Motorola Moto E13", "Motorola Moto E22", "Motorola Moto E32",
  ],
};

// Flat list, useful for default value & quick iteration
export const PHONE_MODELS = Object.entries(PHONE_BRANDS).flatMap(
  ([brand, models]) => models
);
